var render = function render(){var _vm=this,_c=_vm._self._c;return _c('woot-modal',{staticClass:"contact-form-modal",attrs:{"show":_vm.show,"on-close":_vm.onCancel},on:{"update:show":function($event){_vm.show=$event}}},[_c('contact-form',{attrs:{"contact":_vm.contact,"in-progress":_vm.uiFlags.isUpdating,"on-submit":_vm.onSubmit},on:{"success":_vm.onSuccess,"cancel":_vm.onCancel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }